import config from '../config';
import { API_ROUTES, buildCardsQuery } from '../../../shared/api';
import type { Card, CardsResponse, CardSearchParams, Filters } from '../../../shared/types';

/** GET helper for the public card endpoints (no auth required). */
async function getJson<T>(path: string): Promise<T> {
  const res = await fetch(`${config.apiUrl}${path}`);
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    const message =
      (data && data.error && data.error.message) || `Request failed (${res.status})`;
    throw new Error(message);
  }
  return data as T;
}

export const cardsApi = {
  /** Paginated + filtered card search. */
  search: (params: CardSearchParams) =>
    getJson<CardsResponse>(`${API_ROUTES.cards}${buildCardsQuery(params)}`),

  /** Full detail for a single card by its canonical name. */
  get: (name: string) => getJson<Card>(API_ROUTES.card(name)),

  /** Filter option lists (categories, attributes, sets, rarities). */
  filters: () => getJson<Filters>(API_ROUTES.cardFilters),
};
